import React from 'react'

import FilterAccommodationType from 'client/components/FilterAccommodationTypes'
import FilterCategory from 'client/components/FilterCategory'
import FilterFacilities from 'client/components/FilterFacilities'
import FilterFamily from 'client/components/FilterFamily'
import FilterPrices from 'client/components/FilterPrices'
import FilterRatings from 'client/components/FilterRatings'

const Filters = () => (
  <>
    <FilterPrices />
    <FilterCategory />
    <FilterRatings />
    <FilterFamily />
    <FilterAccommodationType />
    <FilterFacilities />
  </>
)

export default Filters
